import React from 'react';

import { TooltipPosition } from 'components/common/CustomizedTooltip/customizedTooltip.enums';
import Icon from 'components/common/Icons/base/Icon/Icon';

import { CustomizedDropdownMenu, CustomizedRoundIcon, CustomizedTooltip } from 'components/common';

export const ActionButtonMenu = ({
    children,
    id,
    tooltipContent,
}: {
    children: React.ReactNode;
    id: string;
    tooltipContent: string;
}) => (
    <CustomizedDropdownMenu
        triggerElement={
            <CustomizedTooltip
                tooltipPosition={TooltipPosition.Top}
                tooltipContent={tooltipContent}
                triggerElement={
                    <CustomizedRoundIcon size={'30px'} id={id}>
                        <Icon name={'three-dot-icon'} color={'var(--button-tertiary-fg)'} />
                    </CustomizedRoundIcon>
                }
            />
        }
    >
        {children}
    </CustomizedDropdownMenu>
);
